import React, { useState } from 'react';
import styles from './OrganisationCard.module.css';
import { ISelectionItem } from '../../../Types/Analyse/ISelectionItem';
import Checkbox from '../Checkbox/Checkbox';

export type OrganisationCardProps = {
    organisationName: string;
    templates: ISelectionItem<string>[];
    onChange: (items: ISelectionItem<string>[]) => void;
    color?: string;
    selectAllDisabled?: boolean;
};

const OrganisationCard = ({ 
    organisationName, 
    templates, 
    onChange, 
    color, 
    selectAllDisabled = false 
}: OrganisationCardProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const optionClicked = (item: ISelectionItem<string>, selected: boolean) => {
        const newData = templates.map(i =>
            i.id === item.id ? { ...i, selected } : i
        );
        onChange(newData);
    };

    const selectAllClicked = (selected: boolean) => {
        const newSelectedItems = templates.map(item => ({
            ...item,
            selected,
        }));
        onChange(newSelectedItems);
    };

    return (
        <div className={`${styles.container} ${isExpanded ? styles.expanded : ''}`}>
            {/* Organisation Header - Always Visible */}
            <div 
                className={styles.organisationHeader}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <h4 className={styles.organisationName}>{organisationName}</h4>
                <img 
                    src="/img/down-arrow.svg" 
                    className={`${styles.expandIcon} ${isExpanded ? styles.expanded : ''}`}
                    alt="Expand"
                />
            </div>

            {/* Templates Section - Visible on Click */}
            {isExpanded && (
                <div className={styles.templatesSection}>
                    {!selectAllDisabled && (
                        <div className={styles.selectAllContainer}>
                            <span className={styles.selectAllText}>Select All Templates</span>
                            <Checkbox
                                color={color}
                                clickHandler={selectAllClicked}
                                value={templates.every((item) => item.selected) && templates.length > 0}
                            />
                        </div>
                    )}
                    
                    <div className={styles.templatesList}>
                        {templates.map((template) => (
                            <div 
                                key={template.id} 
                                className={`${styles.templateItem} ${template.disabled ? styles.disabled : ''}`}
                                style={template.disabled ? { opacity: 0.3 } : {}}
                            >
                                <span className={styles.templateText}>{template.text}</span>
                                <Checkbox
                                    color={color}
                                    disabled={template.disabled}
                                    clickHandler={(selected) => optionClicked(template, selected)}
                                    value={template.selected}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrganisationCard;
